import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/base/SectionHeading";
import { getAllArticles } from "@/lib/content";

export default function EditorPicks() {
  const picks = getAllArticles().filter((item) => !item.featured).slice(0, 4);
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="max-w-content mx-auto">
        <SectionHeading
          eyebrow="Deep Read"
          title="深度阅读"
          desc="不追热闹的时候，这几篇值得慢慢看。"
        />
        <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-5">
          {picks.map((item) => (
            <ArticleCard key={item.id} article={item} variant="horizontal" />
          ))}
        </div>
      </div>
    </section>
  );
}